import React from "react";
import { GlobalTableStyles } from './globalTableStyles'
import { LnidDeclineInfo, NoteTableHeaderList, RiskCode } from "../../../Models/applicationModels";
import { lindDeclineTableHeaderList } from "../../../constants/tableHeaderList";

interface IGlobalTableProps {
    tableData: LnidDeclineInfo
}

const LnidDeclineTable = (props: IGlobalTableProps) => {
    const { tableData } = props

    const {
        tableStyle,
        tableHeader,
        tableCell,
    } = GlobalTableStyles().classes

    return (
        <>
            {tableData?.lnidRiskCodes && tableData?.lnidRiskCodes?.length > 0 &&
                <table className={tableStyle}>
                    <tr>
                        {lindDeclineTableHeaderList?.map((header: NoteTableHeaderList) => {
                            return (
                                <th
                                    className={tableHeader}
                                    style={{ width: header.width }}
                                >
                                    {header.headerName}
                                </th>
                            )
                        })}
                    </tr>
                    {tableData?.lnidRiskCodes?.map((rowValue: RiskCode, index: number) => (
                        <>
                            <tr key={index}>
                                <td className={tableCell}>
                                    {rowValue.description}
                                </td>
                                <td className={tableCell}>
                                    {rowValue.code}
                                </td>
                                <td className={tableCell}>
                                    {rowValue.decision}
                                </td>
                            </tr>
                        </>
                    ))
                    }
                </table>
            }
        </>
    )
}

export default LnidDeclineTable